import { asyncResourceStore } from "./store.js";
export function refresh(options = {}) {
    const { tag, error } = options;
    const resourceIsMatchingError = (resource) => error === undefined || resource.isMatchingError(error);
    asyncResourceStore
        .getAll(tag)
        .filter(resourceIsMatchingError)
        .forEach((resource) => resource.refresh());
}
